import { Skeleton } from 'components/common/skeleton';

import './SkeletonMultipropertyCard.css';
const SkeletonMultipropertyCard = () => {
    return (
        <div>
            <div className="ab-card-multiproperty--skeleton">
                <Skeleton width={195} height={'100%'} minWidth={195} />
                <div className="ab-property_body_container">
                    <div className="ab-room-middle-upper-multiproperty--skeleton">
                        <div className="ab-room-upper-name-multiproperty--skeleton">
                            <Skeleton width={'30%'} height={20} mb={15} />
                            <Skeleton width={'10%'} height={16} mb={15} />
                        </div>
                        <div className="ab-property-upper-score-location-multiproperty--skeleton">
                            <Skeleton width={'20%'} height={30} mb={5} />
                            <Skeleton width={'35%'} height={30} mb={5} />
                            <Skeleton width={'35%'} height={30} mb={5} />
                        </div>
                        {/* <div className="ab-room-upper-description-multiproperty--skeleton">
                        <div className="ab-channels-multiproperty--skeleton">
                            <Skeleton width={'25%'} height={35} />
                            <Skeleton width={'25%'} height={35} />
                            <Skeleton width={'25%'} height={35} />
                        </div>
                    </div> */}

                        {/* <div className="ab-room-upper-notes--skeleton">
                        <Skeleton width={'85%'} height={12} />
                        <Skeleton width={'55%'} height={12} />
                    </div> */}
                    </div>

                    <div className="ab-room-middle-footer-multiproperty--skeleton">
                        <div className="ab-channels-multiproperty--skeleton">
                            <Skeleton width={'30%'} height={35} />
                            <Skeleton width={'30%'} height={35} />
                            <Skeleton width={'30%'} height={35} />
                        </div>
                    </div>
                </div>
                <div className="ab-property-right-container">
                    <div className="ab-old-price">
                        <Skeleton width={'40%'} height={15} mb={15} />
                    </div>
                    <div className="ab-price">
                        <Skeleton width={'60%'} height={30} mb={15} />
                    </div>
                    <div className="ab-providerWrap">
                        <Skeleton width={'60%'} height={20} mb={15} />
                    </div>
                    <div className="ab-freebies">
                        <Skeleton width={'80%'} height={15} mb={15} />
                    </div>
                    <div>
                        <Skeleton width={'95%'} height={30} mb={5} />
                    </div>
                    <div>
                        <Skeleton width={'95%'} height={30} mb={5} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonMultipropertyCard;
